import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import style from '@aytm/app/stats/page/comments/comments/styles/Traits.module.scss'

const Traits = ({ response, survey }) => {
  const { trait } = response
  const { traits } = survey
  const { uid: responseId } = response.response

  const traitsOrder = useMemo(
    () =>
      traits
        .map(trait => ('country' == trait.id ? 'geo' : trait.id))
        .filter(traitName => !['county', 'state'].includes(traitName)),
    [traits]
  )

  const renderTraitItem = traitName => {
    const result = []
    const traitValue = trait[traitName]

    if (traitValue != undefined) {
      switch (traitName) {
        case 'age': {
          // ignore age if age_range trait exists
          if (!traits.some(t => 'age_range' == t?.id)) {
            result.push({
              l: `${trait[traitName]} Age`,
              r: 'at the time of response'
            })
          }
          break
        }
        case 'geo': {
          Object.keys(trait[traitName]).forEach(geoType => {
            switch (geoType) {
              case 'country': {
                result.push({
                  l: trait[traitName][geoType].id,
                  r: geoType
                })
                break
              }
              case 'county':
              case 'state': {
                result.push({
                  l: trait[traitName][geoType].text,
                  r: geoType
                })
                break
              }
              default:
                break
            }
          })
          break
        }
        default: {
          const _trait = traits.find(t => traitName == t?.id)
          if (_trait) {
            const traitValueArr = _trait.values.reduce((acc, item) => {
              if (Array.isArray(traitValue)) {
                if (traitValue.includes(item.id)) {
                  acc.push(item.name)
                }
              } else {
                if (traitValue == item.id) {
                  acc.push(item.name)
                }
              }
              return acc
            }, [])

            result.push({
              l: traitValueArr.join(', '),
              r: _trait.title
            })
          }
          break
        }
      }
    }

    return result.map((item, index) => (
      <li key={`response${responseId}-trait-${traitName}-${index}`} className={style['trait-item']}>
        <span>
          <em>{item.l}</em> - {item.r}
        </span>
      </li>
    ))
  }

  return <ul className={style['traits-container']}>{traitsOrder.map(traitName => renderTraitItem(traitName))}</ul>
}

Traits.propTypes = {
  survey: PropTypes.object,
  response: PropTypes.object
}

Traits.displayName = 'Traits'

export default Traits
